module.exports = __webpack_public_path__ + "img/beer_factory.2fcc0f59.webp";